// extracted by mini-css-extract-plugin
export default {"footer":"B_br","row":"B_cF","menuColumn":"B_cG","trademarks":"B_cH"};